<div class="g-modal-v2 confirm-phone-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'confirm_phone_modal.title' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <div class="g-modal-v2-content">
    @if (state() === 'title') {
      @let phoneNumber = customerService.customer().contactInfo.phoneNumber | mask:PHONE_NUMBER_MASK;
      <div
        class="description g-html-description"
        [innerHTML]="'confirm_phone_modal.description' | translate:{ phoneNumber }"
      >
      </div>

      @if (error()) {
        <div class="g-form-error">
          {{ error() }}
        </div>
      }
    } @else if (state() === 'otp') {
      <tc-otp
        [otpRequest]="otpRequest()"
        [otpDigitsFormArray]="otpDigitsFormArray"
        [isLoading]="isLoading()"
        [error]="error()"
        (submitted)="onSubmit()"
        (resendOtp)="confirmPhoneNumberInit()"
      >
      </tc-otp>
    } @else {
      <div class="success-header">
        {{ 'confirm_phone_modal.success_header' | translate }}
      </div>

      <div class="success-text g-html-description">
        {{ 'confirm_phone_modal.success_text' | translate }}
      </div>
    }

    @if (state() !== 'otp') {
      <tc-button
        class="confirm-phone-modal-submit"
        [isLoading]="isLoading()"
        buttonSize="large"
        (click)="onSubmit()"
      >
        @if (state() === 'title') {
          {{ 'global.send_otp' | translate }}
        } @else {
          {{ 'global.done' | translate }}
        }
      </tc-button>
    }
  </div>
</div>
